<div class="admin-page-title">
  <eps-button
    (buttonClick)="cancelClicked.emit()"
    label="SHARED.BUTTONS.BACK"
  ></eps-button>
  <div class="content">
    <app-title
      *ngIf="isEdit"
      title="ADMIN.SHARED.EDIT"
      subtitle="ADMIN.SHARED.CLIENTUSER"
    ></app-title>
    <app-title
      *ngIf="isCreate"
      title="ADMIN.SHARED.CREATE"
      subtitle="ADMIN.SHARED.CLIENTUSER"
    ></app-title>
    <app-title
      *ngIf="isInvitation"
      title="ADMIN.SHARED.INVITE"
      subtitle="ADMIN.SHARED.CLIENTUSER"
    ></app-title>
  </div>
</div>

<div
  class="button-container row"
  *ngIf="isEdit"
>
  <div class="col-12 col-md-12 col-lg-11">
    <div
      class="buttons"
      @easeInOut
      *ngIf="userContext.adminRoles.resetPassword"
    >
      <eps-button
        *ngIf="userContext.adminRoles.resetPassword"
        buttonIcon="plus-square"
        (buttonClick)="!buttonIsDisabled() && resetPassword.emit(user.id)"
        [disabled]="buttonIsDisabled()"
        [busy]="resettingPassword"
        label="ADMIN.SHARED.RESET_PASSWORD"
      ></eps-button>
    </div>
  </div>
</div>

<div class="filter-container row">
  <div class="filter-container-inner col-12 col-md-12 col-lg-11">
    <form
      class="userForm"
      [formGroup]="userForm"
    >
      <eps-label-body
        label="ADMIN.EPS_USERS.EMAIL"
        *ngIf="isEdit"
      >
        <div class="email-with-copybutton">
          <eps-text-input
            formControlName="email"
            [readonly]="isEdit"
            labelPosition="none"
          ></eps-text-input>
          <i
            class="fa fa-clipboard"
            ngxClipboard
            [cbContent]="user.email"
            (click)="copyToClipboard()"
            *ngIf="isEdit || isView"
          ></i>
          <div
            class="mat-tooltip"
            *ngIf="cbFeedback"
          >
            {{ 'ADMIN.SHARED.COPIED' | translate }}
          </div>
        </div>
      </eps-label-body>

      <eps-text-input
        formControlName="email"
        [readonly]="isEdit"
        label="ADMIN.EPS_USERS.EMAIL"
        *ngIf="isCreate"
      ></eps-text-input>

      <eps-text-input
        formControlName="alternateEmail"
        [readonly]="isView"
        label="ADMIN.EPS_USERS.ALTERNATE_EMAIL"
        hideOptionalMarker
      ></eps-text-input>

      <eps-text-input
        formControlName="firstName"
        [readonly]="isView"
        label="ADMIN.EPS_USERS.NAME"
        hideOptionalMarker
      ></eps-text-input>

      <eps-text-input
        formControlName="lastName"
        [readonly]="isView"
        label="ADMIN.EPS_USERS.LAST_NAME"
        hideOptionalMarker
      ></eps-text-input>

      <eps-select
        formControlName="language"
        [options]="adminDefinitions.language"
        [readonly]="isView"
        label="ADMIN.CLIENT_USERS.LANGUAGE"
        hideOptionalMarker
      ></eps-select>

      <eps-checkbox
        class="edit"
        formControlName="useEmailActors"
        [readonly]="isView"
        label="ADMIN.CLIENT_USERS.CAN_USE_EMAIL_ACTORS"
        useIconsInReadonly
      ></eps-checkbox>

      <eps-checkbox
        class="edit"
        formControlName="isSuperUser"
        [readonly]="isView"
        label="ADMIN.CLIENT_USERS.IS_SUPER_USER"
        useIconsInReadonly
      ></eps-checkbox>

      <eps-checkbox
        class="edit"
        formControlName="canAccessHomeMarketBonus"
        [readonly]="isView"
        label="ADMIN.CLIENT_USERS.CAN_ACCESS_HOME_MARKET_BONUS"
        useIconsInReadonly
      ></eps-checkbox>

      <eps-checkbox
        class="edit"
        formControlName="isActive"
        [readonly]="isView"
        label="ADMIN.CLIENT_USERS.ACTIVE"
        useIconsInReadonly
      ></eps-checkbox>

      <div class="hr-accent"></div>

      <div class="row">
        <div class="col-12">
          <app-label translationCode="ADMIN.EPS_USERS.CUSTOMER_ROLE_LIST"></app-label>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <app-customer-role-list
            [salesOrganisations]="userContext.salesOrganisations"
            [soldTos]="soldTosOfSalesOrganisation"
            [shipTos]="shipTosOfSoldTo"
            [roles]="adminDefinitions.role"
            [loading]="loading"
            [maxRoles]="isCreate ? 1 : null"
            [readonly]="isView"
            (salesOrganisationIdSelected)="salesOrganisationIdSelected.emit($event)"
            (soldToIdSelected)="soldToIdSelected.emit($event)"
            (isEditing)="isEditing = $event"
            formControlName="customers"
          ></app-customer-role-list>
        </div>
      </div>

      <div class="hr-thick"></div>

      <div
        class="buttons"
        *ngIf="!isView"
      >
        <eps-button
          type="link"
          label="SHARED.BUTTONS.CANCEL"
          (buttonClick)="cancelClicked.emit()"
          [disabled]="resettingPassword"
        ></eps-button>
        <eps-button
          type="primary"
          label="ADMIN.SHARED.UPDATE"
          buttonIcon="check"
          (buttonClick)="_updateUser(userForm.valid)"
          [disabled]="!this.userForm.valid || buttonIsDisabled()"
          [busy]="saving"
          *ngIf="isEdit"
        ></eps-button>
        <eps-button
          type="primary"
          label="ADMIN.SHARED.CREATE"
          buttonIcon="check"
          (buttonClick)="_createUser(userForm.valid)"
          [disabled]="!this.userForm.valid || buttonIsDisabled()"
          [busy]="saving"
          *ngIf="isCreate"
        ></eps-button>
        <eps-button
          type="primary"
          label="ADMIN.SHARED.INVITE"
          buttonIcon="check"
          (buttonClick)="_createUser(userForm.valid)"
          [disabled]="!this.userForm.valid || buttonIsDisabled()"
          [busy]="saving"
          *ngIf="isInvitation"
        ></eps-button>
      </div>
    </form>
  </div>
</div>
